import { useQuery } from '@tanstack/react-query'
import { VirtualCardAPI } from '@apis'

export const useUserReferral = (userId: string | undefined | null) => {
    return useQuery({
        queryKey: ['user-referral', userId],
        queryFn: async () => {
            if (!userId) return null
            try {
                return await VirtualCardAPI.GetUserReferralRequest.fetch(userId)
            } catch (error) {
                console.error('Failed to fetch referral data:', error)
                return null
            }
        },
        enabled: !!userId,
        staleTime: Infinity // data is never considered stale
    })
}